import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EmployeeView } from 'src/app/shared/sdk';
//

@Component({
  selector: 'app-employee-hr-certs-list',
  templateUrl: './employee-hr-certs-list.component.html',
  styleUrls: ['./employee-hr-certs-list.component.scss'],
})
export class EmployeeHrCertsListComponent implements OnInit {
  @Output() mySelected: EventEmitter<EmployeeView[]> = new EventEmitter<EmployeeView[]>();

  constructor() {}

  ngOnInit() {}

  grid_onSelected(items: EmployeeView[]) {
    this.mySelected.emit(items);
  }
}

